import React from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { oktonTheme } from '@okton/platform-ui';

import { App } from './App';

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider theme={oktonTheme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
